import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import RawHtml from 'common/RawHtml';
import { withStyles } from 'theme/withStyles';

const styles = ({ spacing, typography }) => ({
  root: {
    ...typography.p3,
    display: 'block',
    marginTop: spacing.unit * 2,
  },
});

const Help = ({ className, classes, help, id }) => {
  if (!help) {
    return null;
  }
  return (
    <RawHtml id={id} type="span" className={classnames(className, classes.root)}>
      {help}
    </RawHtml>
  );
};

Help.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  help: PropTypes.string,
  id: PropTypes.string,
};

Help.defaultProps = {
  className: 'help-text',
  help: '',
  id: null,
};

export default withStyles(styles)(Help);
